export function AvailabilityBadge({
	available,
	total,
}: {
	available: number;
	total?: number;
}) {
	const color =
		available === 0
			? "bg-red-100 text-red-700"
			: "bg-available-green text-available-text";
	return (
		<span className={`text-[10px] px-2 py-0.5 rounded-md ${color}`}>
			{total !== undefined
				? `${available}/${total} Available`
				: `${available} Available`}
		</span>
	);
}
